import React from "react"
import { Link } from "react-router-dom"
import classnames from "classnames"
import { connect } from "react-redux"
import Avatar from "react-avatar"

import logoutAction from "actions/logoutAction"

import {
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Button,
  Media,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap"

class IndexNavbar extends React.Component {
  render() {
    const { auth, profile } = this.props
    return (
      <>
        <Navbar
          className={classnames(
            "navbar-horizontal navbar-main navbar-dark",
            { "bg-transparent": this.props.transparent },
            { "bg-chift": !this.props.transparent }
          )}
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img
                alt="..."
                src={require("assets/img/brand/faver-white.png")}
              />
            </NavbarBrand>
            <hr className="d-lg-none" />
            {auth.uid ? (
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <UncontrolledDropdown nav>
                  <DropdownToggle className="nav-link pr-0" color="" tag="a">
                    <Media className="align-items-center">
                      <span className="avatar avatar-sm rounded-circle">
                        {auth.photoURL ? (
                          <img alt="..." src={auth.photoURL} />
                        ) : (
                          <Avatar
                            size="40"
                            round
                            name={
                              profile && profile.token
                                ? profile.token.claims.name
                                : ""
                            }
                          />
                        )}
                        {/* <img
                          alt="..."
                          src={
                            !auth.photoURL
                              ? require("assets/img/theme/blank-profile.png")
                              : auth.photoURL
                          }
                        /> */}
                      </span>
                      <Media className="ml-2 d-lg-block">
                        <span className="mb-0 text-sm font-weight-bold text-white">
                          {auth ? auth.displayName : auth.email}
                        </span>
                      </Media>
                    </Media>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </DropdownItem>
                    {auth.uid &&
                    profile.isLoaded &&
                    profile.token.claims.role_merchant ? (
                      <Link to="/m/dashboard">
                        <DropdownItem>
                          <i className="ni ni-single-02" />
                          <span>Dashboard</span>
                        </DropdownItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {auth.uid &&
                    profile.isLoaded &&
                    profile.token.claims.role_admin ? (
                      <Link to="/d/dashboard">
                        <DropdownItem>
                          <i className="ni ni-single-02" />
                          <span>Dashboard</span>
                        </DropdownItem>
                      </Link>
                    ) : (
                      ""
                    )}
                    {auth.uid &&
                    profile.isLoaded &&
                    !profile.token.claims.role_admin &&
                    !profile.token.claims.role_merchant ? (
                      <div>
                        <Link to="/orders">
                          <DropdownItem>
                            <i className="fas fa-receipt" />
                            <span>Your Orders</span>
                          </DropdownItem>
                        </Link>
                        <Link to="/account">
                          <DropdownItem>
                            <i className="ni ni-single-02" />
                            <span>Your Account</span>
                          </DropdownItem>
                        </Link>
                      </div>
                    ) : (
                      ""
                    )}
                    {/*<Link to="/m/profile">
                    <DropdownItem>
                      <i className="ni ni-single-02" />
                      <span>My profile</span>
                    </DropdownItem>
                    </Link>
                    <DropdownItem
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <i className="ni ni-support-16" />
                      <span>Support</span>
                    </DropdownItem>
                    <DropdownItem divider />*/}
                    <DropdownItem onClick={this.props.logoutAction}>
                      <i className="ni ni-user-run" />
                      <span>Logout</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            ) : (
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <NavItem>
                  {/* <Link
                  to={{
                    pathname: `/a/login`,
                    state: {
                      redirectPath: this.props.redirectPath
                    }
                  }}>
                    <span className="nav-link-inner--text text-white">Login</span>
                  </Link> */}
                  {/* <NavLink to="/a/login" tag={Link}> */}
                  <NavLink
                    to={{
                      pathname: `/a/login`,
                      state: {
                        redirectPath: this.props.redirectPath,
                      },
                    }}
                    tag={Link}
                  >
                    <span className="nav-link-inner--text text-white">
                      Login
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem className=" d-lg-block ">
                  <NavLink to="/a/register" tag={Link}>
                    <Button
                      className="btn-neutral btn-icon"
                      color="white"
                      outline
                      href=""
                      target="_blank"
                    >
                      <span className="nav-link-inner--text text-white">
                        Sign Up
                      </span>
                    </Button>
                  </NavLink>
                </NavItem>
              </Nav>
            )}
          </Container>
        </Navbar>
      </>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  logoutAction: () => dispatch(logoutAction()),
})

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexNavbar)
